import gsap from "gsap";
export function loadAnimation() {
  const targets = document.querySelectorAll("[data-load-item]");
  const mask = document.querySelector(".mask");

  gsap.set(targets, {
    y: 100,
    autoAlpha: 0,
  });

  gsap.to(mask, {
    autoAlpha: 0,
    duration: 0.3,
    delay: 0.2,
    onComplete() {
      mask.style.display = "none";
    },
  });

  gsap.to(targets, {
    y: 0,
    autoAlpha: 1,
    stagger: 0.2,
    delay: 0.4,
    duration: 0.7,
  });
}
